import React from 'react'
import { APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE, ROUTE_PATH } from '../../../app/constants'
import { ConfirmCriminalRecordCheck } from '../../MRA/Renewals/ConfirmCriminalRecordCheck'
import { useSelector } from "react-redux";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils';

export const RenewalCriminalRecordCheck = (props) => {
    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType);
    let nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.RENEWAL_APPLICATION_REVIEW}`
    if(applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
        nextUrl = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.RENEWAL_TRUST_ACCOUNT}`
    }

    return (
        <ConfirmCriminalRecordCheck {...props} nextUrl={`${nextUrl}`} />
    )
}
